import { atom, useAtom } from "jotai"
import { useCallback, useEffect, useMemo } from "react"

// const searchQueryParam = "s"

// const getUrlAndMaskedUrl = () => {
//   const currentUrl = new URL(window.location.href)
//   if (Router.pathname !== "/404") {
//     return [currentUrl, currentUrl]
//   }
//   // This is 404 route and we dont want to mess with next router internal url, which should remain as /404 or it will re-render whole app on update
//   return [new URL("/404", window.location.origin), currentUrl]
// }

// const openSearch = () => {
//   const [currentUrl, maskedUrl] = getUrlAndMaskedUrl()
//   currentUrl.searchParams.set(searchQueryParam, "")
//   maskedUrl.searchParams.set(searchQueryParam, "")
//   Router.replace(currentUrl, maskedUrl, { shallow: true })
// }

// const closeSearch = () => {
//   const [currentUrl, maskedUrl] = getUrlAndMaskedUrl()
//   currentUrl.searchParams.delete(searchQueryParam)
//   maskedUrl.searchParams.delete(searchQueryParam)
//   Router.replace(currentUrl, maskedUrl, { shallow: true })
// }

// const toggleSearch = () => {
//   const [currentUrl, maskedUrl] = getUrlAndMaskedUrl()

//   if (typeof maskedUrl.searchParams.get(searchQueryParam) !== "string") {
//     currentUrl.searchParams.set(searchQueryParam, "")
//     maskedUrl.searchParams.set(searchQueryParam, "")
//   } else {
//     currentUrl.searchParams.delete(searchQueryParam)
//     maskedUrl.searchParams.delete(searchQueryParam)
//   }
//   Router.replace(currentUrl, maskedUrl, { shallow: true })
// }

// const updateSearchParam = (rawSearchTerm: string) => {
//   return requestAnimationFrame(() => {
//     const [currentUrl, maskedUrl] = getUrlAndMaskedUrl()
//     const searchTerm = rawSearchTerm.trim()

//     // avoid unnecessary updates with eg. empty string
//     if (maskedUrl.searchParams.get(searchQueryParam) !== searchTerm) {
//       currentUrl.searchParams.set(searchQueryParam, searchTerm)
//       maskedUrl.searchParams.set(searchQueryParam, searchTerm)
//       Router.replace(currentUrl, maskedUrl, { shallow: true })
//     }
//   })
// }

// const actions = {
//   toggleSearch,
//   openSearch,
//   closeSearch,
//   updateSearchParam,
// }

const searchAtom = atom(false)

export const useSearchActions = () => {
  const [isOpen, setIsOpen] = useAtom(searchAtom)

  const toggleSearch = useCallback(() => {
    setIsOpen((s) => !s)
  }, [setIsOpen])

  const closeSearch = useCallback(() => {
    setIsOpen(false)
  }, [setIsOpen])

  const openSearch = useCallback(() => {
    setIsOpen(true)
  }, [setIsOpen])

  return useMemo(
    () => ({
      isOpen,
      closeSearch,
      toggleSearch,
      openSearch,
    }),
    [openSearch, isOpen, closeSearch, toggleSearch]
  )
}

export function useAttachGlobalSearchKeyboardShortcut(onToggle: () => void) {
  useEffect(() => {
    // open search with cmd+k key press
    const callback = (e: KeyboardEvent) => {
      if (e.key === "k" && (e.ctrlKey || e.metaKey)) {
        e.preventDefault()
        e.stopPropagation()
        onToggle()
      }
    }

    window.addEventListener("keydown", callback, { capture: true })
    return () => {
      window.removeEventListener("keydown", callback, { capture: true })
    }
  }, [onToggle])
}

// export const useIsSearchOpen = () => {
//   const {
//     query: { [searchQueryParam]: searchString },
//     isReady,
//   } = useRouter()

//   return useMemo(
//     () => isReady && typeof searchString === "string",
//     [isReady, searchString]
//   )
// }

// export const useSearchValue = () => {
//   const {
//     query: { [searchQueryParam]: searchString },
//   } = useRouter()

//   // Static pages + query param == client side only or we get into trouble. This should weed out mistakes too
//   if (typeof window === "undefined") {
//     throw "useSearchValue is client side only to avoid un-desired side effects"
//   }

//   return typeof searchString === "string" ? searchString : undefined
// }
